import swal from 'sweetalert';

const sendToClipBoard = (value, message) => {
    const el = document.createElement('textarea');
    el.value = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    swal({
        text: message,
        buttons: false
    });
}

export default sendToClipBoard;